import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
export const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
  maxWidth: '100%',
	maxHeight: '75%',
	transform: 'translate(-50%, -50%)',
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
	overflowY: "scroll",
};

export function PageCentered({children, direction="row"}){
	return (
		<Container sx={{display: "flex", flexDirection:direction, height:"100%"}}>
			<Box sx={{flexGrow: 1}}>
			</Box>
			<Box sx={{flexGrow: 1}}>
				{children}
			</Box>
			<Box sx={{flexGrow: 1}}>
			</Box>
		</Container>
	)
}
